import { render } from "./AdicionarHospedagem.vue?vue&type=template&id=58839130&scoped=true"
import script from "./AdicionarHospedagem.vue?vue&type=script&lang=js"
export * from "./AdicionarHospedagem.vue?vue&type=script&lang=js"

import "./AdicionarHospedagem.vue?vue&type=style&index=0&id=58839130&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58839130"]])

export default __exports__